<template>
  <v-container class="iframe-body modal_content px-6">
    <div>
      <v-img
        class="mx-auto ml-sm-0"
        :max-height="94"
        :max-width="103"
        src="@/assets/img-success.png"
      />
    </div>

    <h1 class="text-center text-sm-left mb-5 ">
      {{ $t('successfull.title') }}
    </h1>
    <div class="outline-box">
      <img
        height="19"
        width="19"
        src="@/assets/icon-sucessfully.svg"
        style="margin:auto;"
      />

      <p>
        {{ $t('successfull.text1[0]') }} {{ envelopeID }}
        {{ $t('successfull.text1[1]') }} {{ documents.join(', ') }}
        <span style="font-weight: 700">{{ $t('successfull.text1[2]') }}</span>
        {{ $t('successfull.text1[3]') }}
      </p>
    </div>

    <v-row v-if="!hasIdentities" justify="center">
      <v-col cols="12" class="d-none d-sm-flex">
        <div class="link-inline">
          <b style="font-weight:600">
            {{ $t('successfull.cmdStoreText[0]') }}
          </b>
          <a @click="storeCMD()">
            {{ $t('successfull.cmdStoreText[1]') }}
            <img src="@/assets/link.svg" class="Shape" />
          </a>
          {{ $t('successfull.cmdStoreText[2]') }}
        </div>
      </v-col>
    </v-row>
    <v-footer fixed class="iframe-footer">
      <v-container grid-list-md text-center>
        <v-layout justify-end>
          <v-btn
            v-if="!hasIdentities && $vuetify.breakpoint.smAndUp"
            id="advance-btn"
            depressed
            @click="storeCMD"
            class="advance button-iframe"
            >{{ $t('successfull.cmdStoreBtn') }}
          </v-btn>

          <v-btn
            v-else
            id="advance-btn"
            depressed
            @click="submitStep"
            class="advance button-iframe"
            >{{ $t('button.done') }}</v-btn
          >
        </v-layout>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import mixinQES from '../QES/mixinQES';

export default {
  mixins: [mixinQES],
  computed: {
    ...mapGetters(['envelopeID', 'redirectUrl', 'documents', 'hasIdentities']),
    ...mapGetters({
      hasIdentities: 'qes/hasIdentities',
    }),
  },
  methods: {
    storeCMD() {
      const wallid_url = window.location.host.includes('demo')
        ? 'https://dev.wallid.io/Setup/'
        : 'https://wallid.io/Setup/';

      this.$gtag.event('cmd_store', {
        event_category: 'qes',
        event_label: 'qes_cmd_store',
      });

      window.open(wallid_url + '?session=' + this.$store.state.session_id_tsp);
    },
    submitStep() {
      console.log('redirect_url: ', this.redirectUrl);
      if (this.redirectUrl) {
        window.location.replace(this.redirectUrl);
      }
    },
  },
};
</script>

<style scoped>
.advance.button-iframe {
  text-transform: none;
}
.iframe-body {
  padding: 28px 12px;
}
</style>
<style lang="scss">
img {
  object-fit: contain;
}
.outline-box {
  padding: 15px;
  text-align: left;
  margin: 0 auto;
  margin-bottom: 18px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #00e284;
  background-color: #d9fbed;
  p {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: var(--charcoal-grey);
    margin-bottom: 0;
    margin-left: 16px;
    word-break: break-word;
  }
}
</style>
